import { useCallback, useEffect, useState } from "react";
import { RadioButtonForm } from "src/components/common/form/checkbox/RadioButtonForm";
import { InputForm } from "src/components/common/form/input/InputForm";
import { SingleDateForm } from "src/components/common/form/SingleDateForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useUiuxStore from "src/store/useUiuxStore";
import { MST7020_R01Dto } from "./Dto_MST7020_R01";
import { SendTargetEmp } from "src/dtos/popbill/CmailDto";
import { sendTypeMap_MST7020_R01, useMST7020_R01Store } from "./Store_MST7020_R01";
import { formatDate } from "src/utils/string/stringUtil";
import { CheckboxButtonMapForm } from "src/components/common/form/checkbox/CheckboxButtonMapForm";

interface Props {
}

export const Info_MST7020_R01 = ({ }: Props) => {
    const { editMST7020_R01, updateEditMST7020_R01, setEditMST7020_R01 } = useMST7020_R01Store();
    const {  } = useCommonCodeStore();
    const { setOrganizaMapModalProps } = useUiuxStore();

	
	const [msgContentReadOnly, setMsgContentReadOnly] = useState(false);
	const [isReserve, setIsReserve] = useState(false);
	const [reserveDtVisible, setReserveDtVisible] = useState(false);
	const [reserveDtPickerPos, setReserveDtPickerPos] = useState<{ top: number; left: number; height: number }>({ top: 0, left: 0, height: 0 });

    
	const settingOrganizaMapModalProps = (
		handleFoucsId: string,
		originalData: MST7020_R01Dto,
	) => {
		setOrganizaMapModalProps({
			selectedEmpList: originalData.sendTarget,
			handleFoucsId, // 코드 검색 후 입력 포커스 이동을 위한 아이디
			onClear: () => {
                setEditMST7020_R01({ ...originalData, sendTarget: [] })
			},
			onConfirm: (data: SendTargetEmp[]) => {
                setEditMST7020_R01({ ...originalData, sendTarget: data })
			}
		})	
	}

    // info 초기값 설정
    useEffect(() => {
        if (editMST7020_R01) {
            setMsgContentReadOnly(editMST7020_R01?.sendMsgId !== 0 
				&& (editMST7020_R01?.senderStatus === '3' || editMST7020_R01?.senderStatus === '4' || editMST7020_R01?.senderStatus === 'failed'));
        }
    }, [editMST7020_R01, updateEditMST7020_R01]); // 모든 의존성 추가

    const handleInputChange = useCallback((field: keyof MST7020_R01Dto, value: any) => {
        if (updateEditMST7020_R01 && editMST7020_R01) {
            if (field === 'msgContent') {
				const shortMessageMaxLength = sendTypeMap_MST7020_R01.find(item => item.value === 'short')?.length ?? 100;
                const newSendType = value.length > shortMessageMaxLength ? 'long' : 'short';

                if (editMST7020_R01.sendType !== newSendType) {
                    setEditMST7020_R01({ ...editMST7020_R01, msgContent: value, sendType: newSendType });
                    return; 
                }
            }
            updateEditMST7020_R01(field, value);
        }
    }, [editMST7020_R01]);
	

    return (
        <div className="w-full h-full flex flex-col border border-gray-300 px-[6px] py-[6px] overflow-x-auto">
            내용
            <textarea
                className={`
					w-full h-[200px] min-h-[200px] border border-gray-300 p-[6px] resize-none
					${msgContentReadOnly ? 'bg-gray-100' : ''}
				`}
                value={editMST7020_R01?.msgContent ?? ''}
				readOnly={msgContentReadOnly}
                onChange={(e) => { handleInputChange('msgContent', e.target.value) }}
            />
            <div className="text-right text-gray-500 text-sm">
                byteLength : {editMST7020_R01?.msgContent?.length} / {sendTypeMap_MST7020_R01.find(item => item.value === editMST7020_R01?.sendType)?.length}
            </div>
            
            <br/>

			
			<InputForm 
				title="제목(장문문자 전용)"
				value={editMST7020_R01?.subject || ''}
				editable={!msgContentReadOnly && editMST7020_R01?.sendType === 'long'}
				name="subject"
				wrapperOption={{
					wrapperStyle: "w-[400px] min-w-[400px] mr-[10px] mb-[5px]",
					titleStyle: "w-[130px] min-w-[130px]",
					inputStyle: "w-[270px] min-w-[270px]",
				}}
				onChange={(e) => { handleInputChange('subject', e.target.value) }}
			/>
			
			<RadioButtonForm
				title="전송타입"
				titleValueMap={sendTypeMap_MST7020_R01}
				value={editMST7020_R01?.sendType ?? ''}
				name="sendType"
				editable={!msgContentReadOnly}
				onChange={(e) => { handleInputChange('sendType', e.target.value) }}
			/>
            
            { editMST7020_R01?.sendMsgId === 0 &&
				<>
					<div className="flex items-center">
						<CheckboxButtonMapForm
							title="예약일시"
							titleValueMap={[{ title: '예약', value: 'Y' }]}
							value={isReserve ? 'Y' : 'N'}
							name="isReserve"
							editable={true}
							onChange={(e) => { setIsReserve(!isReserve) }}
						/>
						<SingleDateForm 
							title="예약일시"
							value={editMST7020_R01?.reserveDT ? new Date(editMST7020_R01.reserveDT) : undefined}
							setValue={(date) => handleInputChange('reserveDT', date)}
							// titleless = {true}
							editable={isReserve === true} 
							visible={reserveDtVisible} setVisible={setReserveDtVisible}
							pickerPos={reserveDtPickerPos} setPickerPos={setReserveDtPickerPos}
							titleless={true}
							resetType="clear"
							timeEditable={true}
						/>
					</div>
					<div className="text-gray-500 font_size_12 mb-[12px]">
						(예약 일시 설정시, 예약시간에 문자가 발송됩니다.)
					</div>
					<div 
						className="border border-gray-300 p-[6px] border-2 cursor-pointer hover:border-blue-dark" 
						onClick={() => { 
							//전송대상은 한번 등록하면 수정 못하게 하기
							if(editMST7020_R01?.sendMsgId === 0) {
								settingOrganizaMapModalProps('sendTarget', editMST7020_R01!) 
							}
						}}>
						<span className="font-bold font_size_14">
							전송대상 {
							editMST7020_R01?.sendTarget && editMST7020_R01?.sendTarget?.length > 0 ?
								`(${editMST7020_R01?.sendTarget?.length}명)` : '설정'
							} 
						</span>
						{editMST7020_R01?.sendTarget?.map((item) => (
							<div key={item.empNo} className="flex items-center">
								<div className="w-[75px] min-w-[75px]"> {item.empNm} </div>	
								<div className="w-[15px] min-w-[15px]"> {` > `} </div>	
								<div className="text-gray-500 text-sm">({item.mobileNo})</div> 
							</div>
						))}
					</div>
				</>
            }
            <div className="w-[300px] max-w-[300px]">
			    {/* editMST7020_R01 : <pre>{JSON.stringify(editMST7020_R01, null, 2)}</pre> <br/> */}
            </div>
        </div>
    )
}